import { FC, ReactNode } from 'react';
/** 组件 */
import SearchFormItem from './subpage/searchFormItem';
// 常量
import SearchFormDisabled from './subpage/disabled';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { TABLE_COLUMN_EMPTY } from '../constants/constant';

export interface SearchFormCustomItemProps extends BaseSearchFormItemProps {
  /** 是否禁用 */
  renderDisabled?: boolean;
  /** 禁用是显示文字 */
  disabledRender?: ReactNode;
}
/** 自定义表单 */
export const SearchFormCustomItem: FC<SearchFormCustomItemProps> = props => {
  const {
    render,
    renderDisabled,
    disabledRender,
    form,
    isTable,
    testId,
    name,
    hideLabel,
    label,
    ...resProps
  } = props;
  const normFile = (e: any) => {
    if (typeof e === 'string') return e.trim();
    if (Array.isArray(e)) {
      const newValue: any[] = e.map(v => {
        if (typeof v === 'string') return v.trim();
        return v;
      });
      return newValue.filter(v => !!v);
    }
    if (e?.target) {
      return e?.target?.value;
    }
    return e;
  };

  return (
    <SearchFormItem
      {...resProps}
      name={name}
      test-id={`${testId}-${name}`}
      getValueFromEvent={normFile}
      label={!hideLabel && label}
    >
      {renderDisabled ? (
        <>
          {disabledRender ? (
            <SearchFormDisabled
              form={form}
              render={disabledRender || TABLE_COLUMN_EMPTY}
              isTable={isTable}
            />
          ) : (
            <SearchFormDisabled name={name} />
          )}
        </>
      ) : (
        render
      )}
    </SearchFormItem>
  );
};

SearchFormCustomItem.displayName = SearchFormItemEnum.SearchFormCustomItem;

export default SearchFormCustomItem;
